import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../widgets/CustomModal";
import CustomBtn from "../../widgets/CustomBtn";
import InfiniteScroll from "../../services/InfiniteScroll";
import {
  addLocation,
  deleteLocation,
  locationList,
  updateLocation,
} from "../../_slice/locationSlice";
import AppContext from "../../context/AppContext";
import editImg from "../../../assets/images/edit.png";
import deleteImg from "../../../assets/images/delete.png";

function Locations() {
  const [modalShow, setModalShow] = useState({ show: false, id: "" });
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: "",
    name: "",
  });
  const [checkedState, setCheckedState] = useState({});
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoader } = useContext(AppContext);
  const campusId = location?.state?.campus?.campId || "";

  // React Hook Form setup
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      address: "",
      type: "",
      campus_id: campusId || "",
    },
  });

  // Watch the 'type' field for changes
  const selectedType = watch("type");

  // Redux selector to get location data and status
  const { locationData, status: locationStatus } = useSelector(
    (state) => state.location
  );

  // Effect to fetch location initially or on status change
  useEffect(() => {
    if (locationStatus === "idle" || campusId) {
      // dispatch(locationList({ setLoader, campusId }));
    }
  }, [campusId, navigate, dispatch, setLoader]);

  // Function to fetch more location
  const fetchMoreLocations = (resetPage) => {
    const pageCount = resetPage > 0 ? resetPage : page;
    dispatch(locationList({ campusId, pageCount, navigate, setLoader }))
      .then((response) => {
        // console.log('response', response);
        if (response?.payload?.data?.locations?.data?.length > 0) {
          setPage(response?.payload?.data?.locations?.current_page + 1);
          setHasMore(
            response?.payload?.data?.locations?.current_page <
            response?.payload?.data?.locations?.last_page
          );
        } else {
          setHasMore(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching more locations:", error);
      });
  };

  // Function to handle checkbox state changes
  const handleCheckboxChange = (event, id, name, type, isDeletedByAdmin) => {
    const checked = event.target.checked;
    setCheckedState((prevState) => ({
      ...prevState,
      [id]: checked,
    }));

    const { campus = { campId: "", campName: "" }, orgId = "" } =
      location?.state || {};
    if (checked) {
      const newState = {
        campus,
        orglocation: {
          locationId: id,
          locationName: name,
          locationType: type,
          isDeletedByAdmin: isDeletedByAdmin,
        },
        orgId,
      };
      navigate("/organization/courses", { state: newState });
    }

    // Store Local Session
    sessionStorage.setItem("locationType", type);
    sessionStorage.setItem(
      "locationIsDeletedByAdmin",
      String(isDeletedByAdmin)
    );
  };

  // Locations are free — create directly, no payment intent and no Stripe.
  const createLocation = (data) => {
    const payload = {
      campus_id: campusId,
      name: data.name,
      address: data.address,
      type: data.type,
    };

    dispatch(addLocation({ data: payload, navigate, setLoader })).then(
      (response) => {
        if (response?.type?.endsWith("/fulfilled")) {
          setModalShow({ show: false, id: "" });
          fetchMoreLocations(1);
        }
      }
    );
  };

  // Function to edit an existing location
  const editLocation = (data) => {
    dispatch(
      updateLocation({ id: modalShow.id, data, navigate, setLoader, campusId })
    );
    setModalShow({ show: false, id: "" });
  };

  // Function to remove a location
  const removeLocation = (id) => {
    dispatch(deleteLocation({ id, navigate, setLoader, campusId })).then(() => {
      // dispatch(locationList({ setLoader, campusId }))
      fetchMoreLocations(1);
    });
    setDeleteModal({ show: false });
  };

  // Effect to reset form values and clear errors when the modal is closed
  useEffect(() => {
    if (!modalShow.show) {
      setValue("name", "");
      setValue("address", "");
      setValue("type", "location");
      clearErrors();
    }
  }, [modalShow.show, setValue, clearErrors]);

  return (
    <>
      <div className="org">
        <div className="org_header d-flex align-items-center justify-content-between">
          <h1 className="org_header_heading">Location/Equipment</h1>
          <button
            type="button"
            className="submit_btn"
            onClick={() => setModalShow({ show: true })}
          >
            + Add
          </button>
        </div>
        <InfiniteScroll
          fetchMoreData={() => fetchMoreLocations(0)}
          hasMore={hasMore}
          isLoading={locationStatus === "loading"}
          threshold={200}
        >
          <div className="org_table table-responsive table-border-0">
            <table className="table">
              <thead>
                <tr>
                  <td className="org_table_column w-5 zone_table_heading"> </td>
                  <td className="org_table_column w-20 zone_table_heading">
                    Name
                  </td>
                  <td className="org_table_column w-15 zone_table_heading">
                    Type
                  </td>
                  <td className="org_table_column w-20 zone_table_heading">
                    Address/Model
                  </td>
                  <td className="org_table_column w-40 text-center zone_table_heading">
                    Action
                  </td>
                </tr>
              </thead>
              <tbody>
                {locationData?.data?.map((item) => (
                  <tr key={`Loci_${item.id}`}>
                    <td className="org_table_row w-5 zone_body_text">
                      <label
                        className="check_box ml-2"
                        htmlFor={`checkbox-${item.id}`}
                      >
                        <input
                          type="checkbox"
                          id={`checkbox-${item.id}`}
                          checked={checkedState[item.id] || false}
                          onChange={(e) =>
                            handleCheckboxChange(
                              e,
                              item.id,
                              item.name,
                              item.type,
                              item.is_deleted_by_admin
                            )
                          }
                        />
                        <span className="checkbox_check"></span>
                      </label>

                      {/* <label className='check_box ml-2' htmlFor={`checkbox-${item.id}`}>
                        <input type='checkbox' id={`checkbox-${item.id}`} />
                        <span className='checkbox_check'></span>
                      </label> */}
                    </td>
                    <td className="org_table_row w-20 zone_body_text">
                      {item.name}
                    </td>
                    <td className="org_table_row w-15 zone_body_text">
                      {item.type}
                    </td>
                    <td className="org_table_row w-20 zone_body_text">
                      {item.address}
                    </td>
                    <td className="org_table_row w-40 zone_body_text">
                      <div className="d-flex align-items-center justify-content-center">
                        {(() => {
                          const isDisabled = item.is_deleted_by_admin === true;
                          const disabledStyle = isDisabled
                            ? { opacity: 0.5, cursor: "not-allowed" }
                            : {};
                          return (
                            <>
                              <button
                                type="button"
                                className="action_btns mr-4"
                                style={disabledStyle}
                                disabled={isDisabled}
                                onClick={() => {
                                  if (isDisabled) return;
                                  setModalShow({ show: true, id: item.id });
                                  setValue("name", item.name);
                                  setValue("address", item.address);
                                  setValue("type", item.type);
                                }}
                              >
                                <img src={editImg} alt="edit" className="mr-1" />
                                Edit
                              </button>

                              <button
                                type="button"
                                className="action_btns"
                                style={disabledStyle}
                                disabled={isDisabled}
                                onClick={() => {
                                  if (isDisabled) return;
                                  setDeleteModal({
                                    show: true,
                                    id: item.id,
                                    name: item.name,
                                  });
                                }}
                              >
                                <img src={deleteImg} alt="delete" className="mr-1" />
                                Delete
                              </button>
                            </>
                          );
                        })()}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </InfiniteScroll>
      </div>

      <CustomModal
        show={modalShow.show}
        onHide={() => setModalShow({ show: false })}
        heading={
          modalShow.id ? "Edit Location/Equipment" : "Add Location/Equipment"
        }
        size="lg"
        body={
          <form
            onSubmit={
              modalShow.id
                ? handleSubmit(editLocation)
                : handleSubmit(createLocation)
            }
          >
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="innerlable">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="type here"
                    {...register("name", { required: "Name is required" })}
                  />
                  {errors.name && (
                    <p className="text-danger">{errors.name.message}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="innerlable">Type</label>
                  <select
                    name="type"
                    className="form-control custom-select"
                    {...register("type", { required: "Type is required" })}
                  >
                    <option value="location">Location</option>
                    <option value="equipment">Equipment</option>
                    {/* {incidentTypeList?.data?.map((inciType, index) => (
                      <option key={`inciType${index}`} value={inciType?.id}>
                        {inciType?.name}
                      </option>
                    ))} */}
                  </select>
                  {errors.type && (
                    <p className="text-danger">{errors.type.message}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-6 mt-3">
                <div className="form-group">
                  <label className="innerlable mb_top">
                    {selectedType === "equipment"
                      ? "Model"
                      : "Address (Optional)"}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="type here"
                    {...register("address")}
                  />
                </div>
              </div>
              <div className="col-lg-6 mt-4">
                <CustomBtn
                  buttonText="Save"
                  className="mt-5"
                  type="submit"
                  id="locationName"
                />
              </div>
            </div>
          </form>
        }
      />

      <CustomModal
        show={deleteModal.show}
        onHide={() => setDeleteModal({ show: false })}
        size="md"
        body={
          <div className="deleteModal">
            <h2
              className="text-center"
              style={{
                fontSize: "22px",
                fontWeight: "700",
                color: "#292929",
                marginBottom: "16px",
              }}
            >
              Delete Location?
            </h2>
            <p
              className="text-center mb-5"
              style={{ color: "#292929", fontSize: "14px", lineHeight: "1.6" }}
            >
              Deleting this location removes it and everything set up under it.
              You can rename and edit the location instead. Are you sure you
              want to delete this location?
            </p>
            <div className="d-flex justify-content-center align-items-center custom_bottom_padding">
              <button
                type="button"
                className="cancleBtn mr-3"
                onClick={() => setDeleteModal({ show: false })}
              >
                No
              </button>
              <button
                type="button"
                className="submit_btn"
                onClick={() => removeLocation(deleteModal.id)}
              >
                Yes
              </button>
            </div>
          </div>
        }
      />

    </>
  );
}

export default Locations;